import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const markerPosition = {
	transform: 'translate(-50%, -100%)',
};

const MarkerPrice = (props) => {
	const { id, price, isFav, onClick, isActive, isVisitedView } = props;
	const handleClick = React.useCallback(() => {
		if (onClick) onClick({ id });
	}, [id, onClick]);

	return (
		<div
			className={cn('MarkerPrice', {
				MarkerPrice_active: isActive,
				MarkerPrice_visited: isVisitedView,
			})}
			onClick={handleClick}
			tabIndex={0}
			role="button"
		>
			<div className="MarkerPrice__cols" style={markerPosition}>
				<div className="MarkerPrice__val">{price}</div>
				{isFav && <i className="MarkerPrice__fav" />}
			</div>
		</div>
	);
};

MarkerPrice.propTypes = {
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	price: PropTypes.string,
	isFav: PropTypes.bool,
	isVisitedView: PropTypes.bool,
	isActive: PropTypes.bool,
	onClick: PropTypes.func,
};

MarkerPrice.defaultProps = {
	id: undefined,
	price: undefined,
	isFav: false,
	isVisitedView: false,
	isActive: false,
	onClick: undefined,
};

export default MarkerPrice;
